module.exports = __webpack_public_path__ + "static/icons/icon-caret-right-b40630ede00966a1d204c55fa201063c.svg";